<template>
  <bulk-details-grid :preset="preset">
    <bulk-details-table-wrapper with-padding>
      <bulk-details-cell
        v-for="i in rows"
        :key="i"
      >
        <template v-slot:title>
          <tm-skeleton
            type="QChip"
            height="12px"
            random-width
            class="mt-1"
          />
        </template>
        <tm-skeleton
          type="QChip"
          height="12px"
          random-width
        />
      </bulk-details-cell>
    </bulk-details-table-wrapper>

    <slot />
  </bulk-details-grid>
</template>

<script setup lang="ts">
import BulkDetailsGrid from '@/components/shared/bulkDetails/BulkDetailsGrid.vue'
import BulkDetailsTableWrapper from '@/components/shared/bulkDetails/BulkDetailsTableWrapper.vue'
import BulkDetailsCell from '@/components/shared/bulkDetails/BulkDetailsCell.vue'
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'
import type { BulkDetailsGridPreset } from '@/components/shared/types'

const { rows = 10, preset = 'column' } = defineProps<{
  rows?: number
  preset?: BulkDetailsGridPreset
}>()
</script>

<style lang="scss" scoped>
.tm-skeleton-details-table-redesign {
  &__preview {
    border-radius: 8px;
    border: 1px solid $gray2;
    min-width: 300px;
    overflow: hidden;
  }

  &__preview-header {
    padding: 16px 20px;
    border-bottom: 1px solid $gray2;
  }

  &__preview-body {
    padding: 16px 20px;
  }
}
</style>
